import { render, staticRenderFns } from "./LegalSeller.vue?vue&type=template&id=e8f77692&"
import script from "./LegalSeller.vue?vue&type=script&lang=js&"
export * from "./LegalSeller.vue?vue&type=script&lang=js&"
import style0 from "./LegalSeller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports